import { useMemo } from 'react';
import { ROLES, ROLES_PERMISSIONS } from '@/constants';
import { useEnforceAccessControl } from '@/hooks';
import { useAuthStore } from '@/store/useAuthStore';
import { hasRequiredActionsPermissions } from '@/utils/authUtils';
import { isHlbStaffRoles } from '@/components/team-assignments/companyListFilter';
import { DOCS_SETTINGS_ROLES } from '../_components/form/company-general-data/constants';

/**
 * Who may do what on the company profile — the same checks the old edit page
 * and its tabs applied.
 */
export default function useCompanyProfileAccess() {
  const permissions = useAuthStore((state) => state.user?.permissions);
  const roles = useAuthStore((state) => state.user?.roles);
  const canEdit = useEnforceAccessControl(ROLES_PERMISSIONS.COMPANIES.EDIT);

  return useMemo(() => {
    const has = (permission) =>
      hasRequiredActionsPermissions(permissions || [], [permission]);
    return {
      canEdit,
      questionnaire: has('company_questionnaire_view'),
      paymentInstructions: has('company_payment_instructions_view'),
      createDocuments: has('company_create_documents_view'),
      uploadDocuments: has('company_upload_documents_view'),
      // Same roles as the old "Additional documents settings" button.
      docsSettings: DOCS_SETTINGS_ROLES.some((role) => roles?.includes(role)),
      // The HLB team on the client — HLB staff only (team assignments).
      team: isHlbStaffRoles(roles || []),
      // The client's own view of the contacts; the server asks about THIS company.
      clientContacts: [ROLES.client, ROLES.clientOfficer].some((role) => roles?.includes(role)),
    };
  }, [permissions, roles, canEdit]);
}
